import { HttpClient } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { MessageService, PrimeNGConfig } from 'primeng/api';
import { environment } from '../environments/environment';
import { AuthService, UtilityService } from './core/services';
import { initializeApp } from 'firebase/app';
import { getMessaging, isSupported, getToken, onMessage } from 'firebase/messaging';
import { LocalStorageService } from './core/services/shared-services/local-storage.service';
import { NavigationEnd, Router } from '@angular/router';
import { filter } from 'rxjs/operators';
import { GtmService } from './core/services/shared-services/gtm.service';
import { LocalizationService } from './core/services/shared-services/localization.service';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    standalone: false
})
export class AppComponent implements OnInit {
  menuMode = 'static';
  show = true;
  layout = 'blue';

  theme = 'blue';

  ripple: boolean;

  colorScheme = 'light';

  constructor(
    private authService: AuthService,
    private localStorageService: LocalStorageService,
    private primengConfig: PrimeNGConfig,
    private utilityService: UtilityService,
    private router: Router,
    private messageService: MessageService,
    private localizationService: LocalizationService,
    private gtm: GtmService,
  ) {}

  ngOnInit() {
    initializeApp(environment.firebase);
    this.requestPermission().then(async (permissionsGrantedAndTokenGenerated: boolean) => {
      if (permissionsGrantedAndTokenGenerated) {
        await this.listen();
      }
    });
    this.primengConfig.ripple = true;
    this.ripple = true;

    setInterval(() => {
      if (this.localStorageService.getItem('user') != null) {
        if (!this.authService.isLoggedIn()) {
          console.log('Token Expired');
          sessionStorage.clear();
          localStorage.clear();
          const path = this.router.url.split('?')[0];      // strip off any query‐string
          const segments = path.split('/').filter(s => s);
          
          // if there is *no* exact “sales” segment, expire
          if (!segments.includes('sales')) {
            this.messageService.add({
              severity: 'info',
              summary: 'Session Expired',
              detail: 'Session has been expired, Please login'
            });
            this.router.navigate(['/login']);
          }
          
        }
      }
    }, 3000);
    if (environment.testing) {
      console.log('testing Env is working');
    } else if (environment.uat) {
      console.log('UAT is working');
    } else if (environment.production) {
      console.log('Production is working');
    } else if (environment.staging) {
      console.log('Staging is working!!!');
    } else if (environment.testing) {
      console.log('testing Env is working!!!!');
    } else if (environment.preprod) {
      console.log('preprod Env is working!!!');
    } else {
      console.log('DEV envirnoment is working!!');
    }

    // get translations
    this.localizationService.loadTranslations().subscribe();

    this.router.events.pipe(
      filter(e => e instanceof NavigationEnd)
    ).subscribe(() => {
      this.gtm.pushPageView();
    });
  }

  async requestPermission(): Promise<boolean> {
    try {
      // test notification fix in webkit ios
      const supported = await isSupported();
      if ('Notification' in window) {
        const notificationPermissions = await Notification.requestPermission();
        if (supported && notificationPermissions === 'granted') {
          try {
            const messaging = getMessaging();
            const currentToken = await getToken(messaging, { vapidKey: environment.vapidKey });

            if (currentToken) {
              console.log('device_id', currentToken);
              localStorage.setItem('device_id', currentToken);
              return true;
            } else {
              console.log('No registration token available. Request permission to generate one.');
              return false;
            }
          } catch (err) {
            console.log('An error occurred while retrieving token. ', err);
            return false;
          }
        } else {
          console.log('Firebase cloud messaging is not supported in this browser.');
          return false;
        }
      } else {
        console.log('Notifications are not supported in this browser.');
        return false;
      }
    } catch (err) {
      console.log('An error occurred while requesting permission. ', err);
      return false;
    }
  }

  async listen() {
    const supported = await isSupported();
    if (supported) {
      try {
        const messaging = getMessaging();

        onMessage(messaging, (payload) => {
          this.utilityService.notifications$.next(payload);
          console.log('Message received.');
        });
      } catch (err) {
        console.log('An error occurred while setting up message listener:', err);
      }
    } else {
      console.log('Firebase cloud messaging is not supported in this browser.');
    }
  }
}

